/**
 * Цвета и отображение типов проекта (project_type).
 * Соответствует ColorLogic из примера трекера.
 */

import { PROJECT_TYPE_CODES } from '@projectSearch/projectFilter';
import { Clapperboard, type LucideIcon } from 'lucide-react';

/** Коды типов — общий с сервером список (PROJECT_TYPE_CODES), порядок — порядок меню */
export const PROJECT_TYPES = PROJECT_TYPE_CODES;
export type ProjectTypeValue = (typeof PROJECT_TYPES)[number];

/** Знак типа: символ («А», «Az», «★») или иконка lucide; рисует ProjectTypeSymbol */
export type ProjectTypeSymbolValue = string | LucideIcon;

export interface ProjectTypeDisplayConfig {
  label: ProjectTypeSymbolValue;
  text: string;
  fontSize: string;
  /** Viewport кнопки в px: как при прежнем inline fontSize (без растяжки букв) */
  typeBtnView: { w: number; h: number };
}

export const PROJECT_TYPE_DISPLAY: Record<ProjectTypeValue, ProjectTypeDisplayConfig> = {
  Common: { label: '•', text: 'Не авторский', fontSize: '40px', typeBtnView: { w: 40, h: 40 } },
  Author: { label: 'А', text: 'Авторский', fontSize: '30px', typeBtnView: { w: 30, h: 30 } },
  Azbooka: { label: 'Az', text: 'Азбука', fontSize: '25px', typeBtnView: { w: 52, h: 26 } },
  Podcast: { label: 'П', text: 'Подкаст', fontSize: '30px', typeBtnView: { w: 30, h: 30 } },
  Special: { label: '★', text: 'Спецпроект', fontSize: '30px', typeBtnView: { w: 30, h: 30 } },
  AudioDrama: { label: Clapperboard, text: 'Аудиоспектакль', fontSize: '30px', typeBtnView: { w: 30, h: 30 } },
  AI: { label: 'AI', text: 'ИИ', fontSize: '25px', typeBtnView: { w: 40, h: 26 } },
};

/** Текстовое название типа для отображения в комбо и списках */
export function getProjectTypeText(type: string | null | undefined): string | null {
  if (!type?.trim()) return null;
  const key = type.trim();
  if (PROJECT_TYPES.includes(key as ProjectTypeValue)) {
    return PROJECT_TYPE_DISPLAY[key as ProjectTypeValue].text;
  }
  return null;
}

/** Цвет символа/иконки типа проекта — из projectColorTokens */
export { getProjectTypeColor } from '@/styles/projectColorTokens';
